import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { CONTENT_DATA } from './data';
import { ContentItem } from './contentItem';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      className="size-full"
      {...other}
    >
      {value === index && (
        <Box sx={{ px: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
    sx: {
      color: '#334155',
      alignItems: 'flex-start',
      px: 2,
      height: 60,
      textTransform: 'none'
    },
    fullWidth: true
  };
}

const CustomTab = styled(Tab)(() => ({
  '&.Mui-selected': {
    color: '#1a1a1a',
    fontWeight: 600,
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 4,
      top: '50%',
      transform: 'translateY(-50%)',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '6px 0 6px 8px',
      borderColor: 'transparent transparent transparent #4F46E5'
    }
  },
  position: 'relative',
  paddingLeft: '24px !important',
  borderBottom: '1px solid #e2e8f0',
  fontSize: '16px'
}));

export default function CookieContent() {
  const [value, setValue] = React.useState(2); // 默认选中Performance Cookies (索引2)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box className="w-full p-1 lg:flex">
      <Tabs
        orientation="vertical"
        value={value}
        onChange={handleChange}
        TabIndicatorProps={{ style: { display: 'none' } }}
        className="w-full shrink-0 lg:w-[260px]"
      >
        {CONTENT_DATA.map((item, index) => (
          <CustomTab
            label={item.title}
            key={item.title}
            {...a11yProps(index)}
          />
        ))}
      </Tabs>
      {CONTENT_DATA.map((item, index) => (
        <TabPanel value={value} index={index} key={item.title}>
          <ContentItem item={item} />
        </TabPanel>
      ))}
    </Box>
  );
}
